import _regeneratorRuntime from 'babel-runtime/regenerator';
import _getIterator from 'babel-runtime/core-js/get-iterator';
import _Object$create from 'babel-runtime/core-js/object/create';
import _Object$keys from 'babel-runtime/core-js/object/keys';
import _typeof from 'babel-runtime/helpers/typeof';
import _Map from 'babel-runtime/core-js/map';
import _extends from 'babel-runtime/helpers/extends';

var _marked5 =
/*#__PURE__*/
_regeneratorRuntime.mark(routeSaga),
    _marked6 =
/*#__PURE__*/
_regeneratorRuntime.mark(historyToStore),
    _marked7 =
/*#__PURE__*/
_regeneratorRuntime.mark(storeToHistory),
    _marked8 =
/*#__PURE__*/
_regeneratorRuntime.mark(saga);

import { eventChannel, buffers } from 'redux-saga';
import { take, put, call, fork, cancel } from 'redux-saga/effects';
import pathToRegexp from 'path-to-regexp';
export var NAVIGATE = 'router/NAVIGATE';
export function navigate(id) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return _extends({
    type: NAVIGATE,
    id: id,
    params: params
  }, opts);
}
export function route(id, path, navigateSaga, querySaga) {
  return {
    id: id,
    path: path,
    navigateSaga: navigateSaga,
    querySaga: querySaga
  };
}
export function buildRoutesMap() {
  for (var _len = arguments.length, routes = Array(_len), _key = 0; _key < _len; _key++) {
    routes[_key] = arguments[_key];
  }

  return new _Map(routes.map(function (route) {
    var id = route.id,
        path = route.path;
    var keys = [];
    var re = pathToRegexp(path, keys);
    var toPath = pathToRegexp.compile(path);
    return [id, _extends({}, route, {
      re: re,
      keys: keys,
      toPath: toPath
    })];
  }));
}
var initialState = {
  id: null,
  params: null,
  query: null,
  prev: null
};
export function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  if (action.type === NAVIGATE) {
    return {
      id: action.id,
      params: action.params,
      query: action.query,
      prev: state.id && _extends({}, state, {
        prev: null
      })
    };
  }

  return state;
} // epoberezkin/fast-deep-equal

export function equal(a, b) {
  if (a === b) {
    return true;
  } // is NaN
  // eslint-disable-next-line no-self-compare


  if (a !== a && b !== b) {
    return true;
  }

  if (a && b && (typeof a === 'undefined' ? 'undefined' : _typeof(a)) === 'object' && (typeof b === 'undefined' ? 'undefined' : _typeof(b)) === 'object') {
    var arrA = Array.isArray(a);
    var arrB = Array.isArray(b);

    if (arrA && arrB) {
      if (a.length !== b.length) return false;

      for (var i = a.length; i-- !== 0;) {
        if (!equal(a[i], b[i])) {
          return false;
        }
      }

      return true;
    }

    if (arrA !== arrB) {
      return false;
    }

    var dateA = a instanceof Date;
    var dateB = b instanceof Date;

    if (dateA !== dateB) {
      return false;
    }

    if (dateA && dateB) {
      return a.getTime() === b.getTime();
    }

    var regexpA = a instanceof RegExp;
    var regexpB = b instanceof RegExp;

    if (regexpA !== regexpB) {
      return false;
    }

    if (regexpA && regexpB) {
      return a.toString() === b.toString();
    }

    var keys = _Object$keys(a);

    if (keys.length !== _Object$keys(b).length) {
      return false;
    }

    for (var _i = keys.length; _i-- !== 0;) {
      if (!Object.prototype.hasOwnProperty.call(b, keys[_i])) {
        return false;
      }
    }

    for (var _i2 = keys.length; _i2-- !== 0;) {
      var key = keys[_i2];

      if (!equal(a[key], b[key])) {
        return false;
      }
    }

    return true;
  }

  return false;
}
export function queryStringify(query) {
  var encode = function encode(input) {
    return encodeURIComponent(input);
  };

  query = query || {};
  return _Object$keys(query).sort().filter(function (key) {
    return query[key] !== undefined;
  }).map(function (key) {
    return [key].concat(query[key] !== null ? [query[key]] : []).map(encode).join('=');
  }).join('&');
}
export function queryParse(query) {
  if (typeof query !== 'string' || !query.length) {
    return null;
  }

  var decode = function decode(input) {
    return decodeURIComponent(input.replace(/\+/g, ' '));
  };

  var parser = /([^=?&]+)=?([^&]*)/g;

  var result = _Object$create(null);

  var part = void 0;

  while (part = parser.exec(query)) {
    var all = decode(part[0]);
    var key = decode(part[1]);
    var value = all === key ? null : decode(part[2]);
    result[key] = key in result ? [].concat(result[key], value) : value;
  }

  return result;
}
export function actionToPath(routesMap, action) {
  var route = routesMap.get(action && action.id) || null;
  var path = route && route.toPath(action.params);
  var query = action && action.query && queryStringify(action.query);
  var parts = path && [path].concat(query || []);
  return parts && parts.join('?');
}
export function pathToAction(routesMap, path, search) {
  var state = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  if (typeof path !== 'string') {
    return null;
  }

  var query = queryParse(search);
  var opts = query && {
    query: query
  };

  var _loop = function _loop() {
    if (_isArray) {
      if (_i3 >= _iterator.length) return 'break';
      _ref = _iterator[_i3++];
    } else {
      _i3 = _iterator.next();
      if (_i3.done) return 'break';
      _ref = _i3.value;
    }

    var _ref2 = _ref,
        id = _ref2[0],
        route = _ref2[1];
    var captures = path.match(route.re);

    if (!captures) {
      return 'continue';
    }

    var params = captures.slice(1).reduce(function (params, capture, index) {
      var key = route.keys[index];
      var value = typeof capture === 'string' ? decodeURIComponent(capture) : capture;
      params[key.name] = value;
      return params;
    }, {});
    return {
      v: navigate(id, _extends({}, params, state), opts)
    };
  };

  _loop2: for (var _iterator = routesMap.entries(), _isArray = Array.isArray(_iterator), _i3 = 0, _iterator = _isArray ? _iterator : _getIterator(_iterator);;) {
    var _ref;

    var _ret = _loop();

    switch (_ret) {
      case 'break':
        break _loop2;

      case 'continue':
        continue;

      default:
        if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
    }
  }

  return navigate('NOT_FOUND');
}
export function createHistoryChannel(history) {
  return eventChannel(function (emitter) {
    emitter({
      location: history.location
    });
    var ignore = history.listen(function (location, action) {
      emitter({
        location: location,
        action: action
      });
    });
    return function () {
      ignore();
    };
  }, buffers.fixed());
}
export function routeSaga(routesMap) {
  var _marked, _marked2, _marked3, _marked4, currentAction, currentNavigateTask, currentQueryTask, cancelCurrentNavigateTask, forkNavigateTask, cancelCurrentQueryTask, forkQueryTask, navigateAction, id, params, query, _route, sameRoute, queryChangeOnly;

  return _regeneratorRuntime.wrap(function routeSaga$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          forkQueryTask = function forkQueryTask(route, params, query) {
            return _regeneratorRuntime.wrap(function forkQueryTask$(_context4) {
              while (1) {
                switch (_context4.prev = _context4.next) {
                  case 0:
                    if (!(route && route.querySaga)) {
                      _context4.next = 4;
                      break;
                    }

                    _context4.next = 3;
                    return fork(route.querySaga, params, query);

                  case 3:
                    currentQueryTask = _context4.sent;

                  case 4:
                  case 'end':
                    return _context4.stop();
                }
              }
            }, _marked4, this);
          };

          cancelCurrentQueryTask = function cancelCurrentQueryTask() {
            return _regeneratorRuntime.wrap(function cancelCurrentQueryTask$(_context3) {
              while (1) {
                switch (_context3.prev = _context3.next) {
                  case 0:
                    if (!currentQueryTask) {
                      _context3.next = 4;
                      break;
                    }

                    _context3.next = 3;
                    return cancel(currentQueryTask);

                  case 3:
                    currentQueryTask = null;

                  case 4:
                  case 'end':
                    return _context3.stop();
                }
              }
            }, _marked3, this);
          };

          forkNavigateTask = function forkNavigateTask(route, params, query) {
            return _regeneratorRuntime.wrap(function forkNavigateTask$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    if (!(route && route.navigateSaga)) {
                      _context2.next = 4;
                      break;
                    }

                    _context2.next = 3;
                    return fork(route.navigateSaga, params, query);

                  case 3:
                    currentNavigateTask = _context2.sent;

                  case 4:
                  case 'end':
                    return _context2.stop();
                }
              }
            }, _marked2, this);
          };

          cancelCurrentNavigateTask = function cancelCurrentNavigateTask() {
            return _regeneratorRuntime.wrap(function cancelCurrentNavigateTask$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    if (!currentNavigateTask) {
                      _context.next = 4;
                      break;
                    }

                    _context.next = 3;
                    return cancel(currentNavigateTask);

                  case 3:
                    currentNavigateTask = null;

                  case 4:
                  case 'end':
                    return _context.stop();
                }
              }
            }, _marked, this);
          };

          _marked =
          /*#__PURE__*/
          _regeneratorRuntime.mark(cancelCurrentNavigateTask), _marked2 =
          /*#__PURE__*/
          _regeneratorRuntime.mark(forkNavigateTask), _marked3 =
          /*#__PURE__*/
          _regeneratorRuntime.mark(cancelCurrentQueryTask), _marked4 =
          /*#__PURE__*/
          _regeneratorRuntime.mark(forkQueryTask);
          currentAction = void 0;
          currentNavigateTask = void 0;
          currentQueryTask = void 0;

        case 8:
          if (!true) {
            _context5.next = 28;
            break;
          }

          _context5.next = 11;
          return take(NAVIGATE);

        case 11:
          navigateAction = _context5.sent;
          id = navigateAction.id, params = navigateAction.params, query = navigateAction.query;
          _route = routesMap.get(id);
          sameRoute = !navigateAction.force && currentAction && currentAction.id === id && equal(currentAction.params, params);
          queryChangeOnly = sameRoute && !equal(currentAction.query || null, query || null);
          currentAction = {
            id: id,
            params: params,
            query: query
          };

          if (sameRoute) {
            _context5.next = 23;
            break;
          }

          return _context5.delegateYield(cancelCurrentQueryTask(), 't0', 19);

        case 19:
          return _context5.delegateYield(cancelCurrentNavigateTask(), 't1', 20);

        case 20:
          return _context5.delegateYield(forkNavigateTask(_route, params, query), 't2', 21);

        case 21:
          _context5.next = 26;
          break;

        case 23:
          if (!queryChangeOnly) {
            _context5.next = 26;
            break;
          }

          return _context5.delegateYield(cancelCurrentQueryTask(), 't3', 25);

        case 25:
          return _context5.delegateYield(forkQueryTask(_route, params, query), 't4', 26);

        case 26:
          _context5.next = 8;
          break;

        case 28:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked5, this);
}
export function historyToStore(routesMap, historyChannel) {
  var _ref3, location, action, pathname, search, state, navigateAction;

  return _regeneratorRuntime.wrap(function historyToStore$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          if (!true) {
            _context6.next = 14;
            break;
          }

          _context6.next = 3;
          return take(historyChannel);

        case 3:
          _ref3 = _context6.sent;
          location = _ref3.location;
          action = _ref3.action;

          if (!(!action || action === 'POP')) {
            _context6.next = 12;
            break;
          }

          pathname = location.pathname, search = location.search, state = location.state;
          navigateAction = pathToAction(routesMap, pathname, search, state);

          if (!navigateAction) {
            _context6.next = 12;
            break;
          }

          _context6.next = 12;
          return put(navigateAction);

        case 12:
          _context6.next = 0;
          break;

        case 14:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked6, this);
}
export function storeToHistory(routesMap, history) {
  var _history$location, pathname, search, currentAction, navigateAction, _id, _params, _query, sameAction, navigatePath;

  return _regeneratorRuntime.wrap(function storeToHistory$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _history$location = history.location, pathname = _history$location.pathname, search = _history$location.search;
          currentAction = pathToAction(routesMap, pathname, search);

        case 2:
          if (!true) {
            _context7.next = 11;
            break;
          }

          _context7.next = 5;
          return take(NAVIGATE);

        case 5:
          navigateAction = _context7.sent;
          _id = navigateAction.id, _params = navigateAction.params, _query = navigateAction.query;
          sameAction = equal(currentAction, {
            id: _id,
            params: _params,
            query: _query
          });

          if (!sameAction) {
            currentAction = {
              id: _id,
              params: _params,
              query: _query
            };
            navigatePath = actionToPath(routesMap, navigateAction);

            if (navigatePath) {
              history[navigateAction.replace ? 'replace' : 'push'](navigatePath, _extends({}, navigateAction.params));
            }
          }

          _context7.next = 2;
          break;

        case 11:
        case 'end':
          return _context7.stop();
      }
    }
  }, _marked7, this);
}
export function saga(routesMap, history) {
  var historyChannel;
  return _regeneratorRuntime.wrap(function saga$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _context8.next = 2;
          return fork(routeSaga, routesMap);

        case 2:
          _context8.next = 4;
          return fork(storeToHistory, routesMap, history);

        case 4:
          _context8.next = 6;
          return call(createHistoryChannel, history);

        case 6:
          historyChannel = _context8.sent;
          _context8.next = 9;
          return fork(historyToStore, routesMap, historyChannel);

        case 9:
        case 'end':
          return _context8.stop();
      }
    }
  }, _marked8, this);
}